import { render, staticRenderFns } from "./DatabaseEditTab.vue?vue&type=template&id=512792e7"
import script from "./DatabaseEditTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatabaseEditTab.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports